export default {
  en: {
    tenantSelection: {
      title: "Select the tenant you want to log in"
    }
  },
  pt: {
    tenantSelection: {
      title: "Selecione o cliente que você deseja logar"
    }
  },
  es: {
    tenantSelection: {
      title: "Seleccione el cliente al que desea conectarse"
    }
  }
}
